module.exports = __webpack_public_path__ + "img/bantusaku.a29aed1e.png";